jQuery(document).ready(function ($) {
    'use strict';

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    var blocs = document.querySelectorAll('.bloc_bandeau');

    if (!blocs.length) {
        return;
    }

    var DUREE = .9;
    var EASE = 'power3.out';

    var DECLENCHEMENT = 'top 80%';

    Array.prototype.forEach.call(blocs, function (bloc) {
        // le triangle est un ::after, non ciblable : on anime la variable
        gsap.set(bloc, {'--triangle-echelle': 0});

        gsap.to(bloc, {
            '--triangle-echelle': 1,
            duration: DUREE,
            ease: EASE,
            scrollTrigger: {
                trigger: bloc,
                start: DECLENCHEMENT,
                once: true
            }
        });
    });
});
